import { render } from "./AtecoView.vue?vue&type=template&id=4e92287a&scoped=true"
import script from "./AtecoView.vue?vue&type=script&lang=js"
export * from "./AtecoView.vue?vue&type=script&lang=js"

import "./AtecoView.vue?vue&type=style&index=0&id=4e92287a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e92287a"]])

export default __exports__